export const employeeConstants = {
	KIND_INTERNAL: 'internal',
	KIND_EXTERNAL: 'external',
};
